import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  programCard: {
    width: '350px',
    height: '150px',
    minHeight: '150px',
    border: 'solid 1px #E5E7ED',
    borderRadius: '4px !important',
    textAlign: 'left',
    cursor: 'pointer',
  },
  cardActionArea: {
    height: '100%',
  },
  cardContent: {
    height: '100%',
  },
  title: {
    lineHeight: '24px',
    marginBottom: '40px',
    fontFamily: 'Roboto Medium',
    fontSize: '1.25rem',
    fontWeight: 500,
    wordBreak: 'break-word',
  },
  gitProgramTitle: {
    lineHeight: '15px',
    marginBottom: '23px',
    fontFamily: 'Roboto Medium',
    fontSize: '1.25rem',
    fontWeight: 500,
    wordBreak: 'break-word',
  },
  programUsers: {
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  owner: {
    fontSize: '14px',
  },
  programOwnerImage: {
    display: 'inline-block',
    width: '24px',
    height: '24px',
    lineHeight: '24px',
    fontWeight: 'normal',
    marginRight: '7px',
    borderRadius: '50px',
    fontSize: '8px',
    backgroundColor: '#1891F6',
  },
  btnRequestAccess: {
    minWidth: '132px !important',
    height: '24px !important',
    cursor: 'pointer',
    color: '#333',
    borderColor: '#BAC0D0',
    textTransform: 'none',
    fontFamily: 'Roboto Medium',
    fontSize: '0.875rem',
    position: 'absolute',
    right: 0,
    top: 0,
  },
  btnPendingAccess: {
    minWidth: '132px !important',
    height: '24px !important',
    color: '#333',
    fontFamily: 'Roboto Medium',
    fontSize: '0.875rem',
    borderColor: '#BAC0D0',
    textTransform: 'none',
    position: 'absolute',
    right: 0,
    top: 0,
  },
}));
